<template>
  <v-container fluid>
    <acceuil id="acceuil"></acceuil>

    <section id="education">
      <v-card class="rounded-0" flat width="100%">
        <v-img
          class="elevation-2 d-flex justify-center align-center"
          :height="$vuetify.breakpoint.smAndUp ? '100px' : '50px'"
          src="@/assets/bcg4.jpg"
          gradient="to top right, rgba(100,115,201,.7), rgba(25,32,72,.7)"
        >
          <h1
            class="text-center white--text"
            :class="$vuetify.breakpoint.smAndUp ? 'display-1' : 'text-h6'"
          >
            {{ $t("sideBarLayout.links[1]") }}
          </h1>
        </v-img>

        <template>
          <v-timeline class="mx-5" flat v-if="$vuetify.breakpoint.smAndUp">
            <v-timeline-item
              v-for="(year, i) in $t('home.years')"
              :key="i"
              :color="year.color"
              small
            >
              <template v-slot:opposite>
                <span
                  class="headline font-weight-bold"
                  v-text="year.year"
                ></span>
              </template>
              <div class="py-4">
                <h3>
                  {{ year.title }}
                </h3>
                <h5>{{ year.text }}</h5>

                <v-list dense>
                  <v-list-item
                    v-for="(cours, index) in year.courses"
                    :key="index"
                    dense
                  >
                    <v-list-item-icon>
                      <v-icon :color="year.color">mdi-circle-medium</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-subtitle class="text-wrap">{{
                        cours
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </div>
            </v-timeline-item>
          </v-timeline>
          <div v-else class="pt-2">
            <div v-for="(year, i) in $t('home.years')" :key="i">
              <h4 align="center">{{ year.title }}</h4>
              <h6 align="center">{{ year.text }}</h6>
              <h5
                align="center"
                class=" font-weight-bold"
                v-text="year.year"
              ></h5>
              <div
                v-for="(cours, index) in year.courses"
                :key="index"
                class="text-caption"
              >
                <v-icon left :color="year.color">mdi-circle-medium</v-icon
                >{{ cours }}
              </div>
              <v-divider class="pb-2 mt-4"></v-divider>
            </div>
          </div>
        </template>
      </v-card>
    </section>
    <section id="experience">
      <v-card class="rounded-0" flat>
        <v-img
          class="elevation-2 d-flex justify-center align-center"
          :height="$vuetify.breakpoint.smAndUp ? '100px' : '50px'"
          src="@/assets/bcg4.jpg"
          gradient="to top right, rgba(100,115,201,.7), rgba(25,32,72,.7)"
        >
          <h1
            class="text-center white--text"
            :class="$vuetify.breakpoint.smAndUp ? 'display-1' : 'text-h6'"
          >
            {{ $t("sideBarLayout.links[2]") }}
          </h1>
        </v-img>

        <template>
          <v-timeline class="mx-5" flat v-if="$vuetify.breakpoint.smAndUp">
            <v-timeline-item
              v-for="(year, i) in $t('home.experiences')"
              :key="i"
              :color="year.color"
              small
            >
              <template v-slot:opposite>
                <span
                  class="headline font-weight-bold"
                  v-text="year.year"
                ></span>
              </template>
              <div class="py-4">
                <h3>
                  {{ year.title }}
                </h3>
                <h5>{{ year.text }}</h5>

                <v-list dense>
                  <v-list-item
                    v-for="(cours, index) in year.courses"
                    :key="index"
                    dense
                  >
                    <v-list-item-icon>
                      <v-icon :color="year.color">mdi-circle-medium</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-subtitle class="text-wrap">{{
                        cours
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </div>
            </v-timeline-item>
          </v-timeline>
          <div v-else class="py-2">
            <div v-for="(year, i) in $t('home.experiences')" :key="i">
              <h4 align="center">{{ year.title }}</h4>
              <h6 align="center">{{ year.text }}</h6>
              <h5
                align="center"
                class=" font-weight-bold"
                v-text="year.year"
              ></h5>
              <div
                v-for="(cours, index) in year.courses"
                :key="index"
                class="text-caption"
              >
                <v-icon left :color="year.color">mdi-circle-medium</v-icon
                >{{ cours }}
              </div>
            </div>
          </div>
        </template>
      </v-card>
    </section>
    <section id="contact">
      <v-card class="rounded-0">
        <v-img
          class="elevation-2 d-flex justify-center align-center"
          height="120"
          src="@/assets/bcg4.jpg"
          gradient="to top right, rgba(100,115,201,.7), rgba(25,32,72,.7)"
        >
          <h1
            class="text-center white--text pb-2"
            :class="$vuetify.breakpoint.smAndUp ? 'display-1' : 'text-h6'"
          >
            {{ $t("sideBarLayout.links[3]") }}
          </h1>
          <div align="center">
            <v-btn
              fab
              dark
              class="mx-2"
              href="https://www.linkedin.com/in/oussama-bouhenniche/"
              target="_blank"
              ><v-icon large>mdi-linkedin</v-icon></v-btn
            >
            <v-btn
              fab
              dark
              class="mx-2"
              href="https://github.com/oussama-floor9"
              target="_blank"
              ><v-icon large>mdi-github</v-icon></v-btn
            >
            <v-btn
              fab
              dark
              class="mx-2"
              href="mailto:oussamabouhenniche14@gmail.com"
              target="_blank"
              ><v-icon large>mdi-email</v-icon></v-btn
            >
          </div>
        </v-img>
      </v-card>
    </section>
    <v-fab-transition>
      <v-btn
        dark
        top
        large
        right
        class="rounded-pill mt-16 mr-2"
        fixed
        color="hsl(224deg 41% 29%)"
        @click="
          downloadItem({
            url: 'cv.pdf',
            label: 'oussama_bouhenniche.pdf'
          })
        "
      >
        <v-icon left large>mdi-download-circle-outline</v-icon>
        {{ $t("download") }}
      </v-btn>
    </v-fab-transition>
  </v-container>
</template>
<script>
import Acceuil from "@/components/Acceuil.vue";
import axios from "axios";
export default {
  components: { Acceuil },
  data() {
    return {};
  },
  methods: {
    async downloadItem({ url, label }) {
      const response = await axios.get(url, { responseType: "blob" });
      const blob = new Blob([response.data], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = label;
      link.click();
      URL.revokeObjectURL(link.href);
    }
  }
};
</script>
